unit DeviceType;

interface

uses
  TemperatureType, TypeType, SupplierType;

type
  TDeviceType = class
  private
    fDeviceKey: String;
    fCode: String;
    fName: String;
    fDeviceType: TTypeType;
    fType: TTypeType;
    fMaxTemperature: TTemperatureType;
    fSupplier: TSupplierType;
    fRemarks: String;
    fApproved: Boolean;
    fActive: Boolean;
  public
    property DeviceKey: String read fDeviceKey;
    property Code: String read fCode;
    property Name: String read fName;
    property DeviceTypeType: TTypeType read fDeviceType;
    property TypeType: TTypeType read fType;
    property MaxTemperature: TTemperatureType read fMaxTemperature;
    property Supplier: TSupplierType read fSupplier;
    property Remarks: String read fRemarks;
    property Approved: Boolean read fApproved;
    property Active: Boolean read fActive;
    constructor Create(const String_DeviceKey: String);
  end;

implementation

constructor TDeviceType.Create(const String_DeviceKey: String);
begin
  inherited Create();

  fDeviceKey := String_DeviceKey;
end;

end.
